
import React from 'react';
import { Procurement } from '@/types/database.types';

interface SourceDetails {
  name: string;
  contact: string;
  address: string;
  bankName: string;
  bankAccount: string;
  bankBranch: string;
}

interface SourceInfoSectionProps {
  procurement: Procurement;
  sourceDetails: SourceDetails;
}

export const SourceInfoSection: React.FC<SourceInfoSectionProps> = ({
  procurement,
  sourceDetails
}) => {
  return (
    <div className="space-y-4">
      <h3 className="text-lg font-medium capitalize">{procurement.source_type} Information</h3>
      <div className="grid grid-cols-2 gap-3">
        <div>
          <p className="text-sm font-medium">Name</p>
          <p className="text-sm">{sourceDetails.name}</p>
        </div>
        <div>
          <p className="text-sm font-medium">Contact</p>
          <p className="text-sm">{sourceDetails.contact}</p>
        </div>
        <div>
          <p className="text-sm font-medium">Address</p>
          <p className="text-sm">{sourceDetails.address}</p>
        </div>
      </div>
      
      {/* Bank Information */}
      {(procurement.source_type === 'supplier' || procurement.source_type === 'agent') && (
        <div className="mt-4">
          <h4 className="text-md font-medium mb-2">Bank Information</h4>
          <div className="grid grid-cols-1 gap-2 bg-muted/30 p-3 rounded-md">
            <div>
              <p className="text-xs font-medium text-muted-foreground">Bank Name</p>
              <p className="text-sm">{sourceDetails.bankName}</p>
            </div>
            <div>
              <p className="text-xs font-medium text-muted-foreground">Account Number</p>
              <p className="text-sm">{sourceDetails.bankAccount}</p>
            </div>
            <div>
              <p className="text-xs font-medium text-muted-foreground">Branch</p>
              <p className="text-sm">{sourceDetails.bankBranch}</p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
